import urls from 'Source/urls';

export const dataModelsUrls = [
  urls.build.dataModels.create(),
  urls.build.dataModels.details(':id'),
  urls.build.dataModels.edit(':id'),
  urls.build.dataModels.list(),
];

export const detectionsUrls = [
  // current
  urls.build.home(),
  urls.build.detections.list(),
  urls.build.detections.create(),
  urls.build.detections.policies.list(),
  urls.build.detections.policies.details(':id'),
  urls.build.detections.policies.edit(':id'),
  urls.build.detections.rules.list(),
  urls.build.detections.rules.details(':id'),
  urls.build.detections.rules.edit(':id'),
  urls.build.detections.rules.replays(':detectionId', ':replayId', ':alertId'),
  urls.build.detections.correlationRules.list(),
  urls.build.detections.correlationRules.details(':id'),
  urls.build.detections.correlationRules.edit(':id'),
  '/build/detections/rules/:id/replay',
  '/build/detections/rules/:id/replay/:replayId/alert',
];

export const helpersUrls = [
  urls.build.globalHelpers.create(),
  urls.build.globalHelpers.edit(':id'),
  urls.build.globalHelpers.list(),
  `${urls.build.globalHelpers.list()}:id`,
];

export const packsUrls = [
  urls.build.packs.list(),
  urls.build.packs.details(':id'),
  urls.build.packs.packSources.home(),
  urls.build.packs.packSources.list(),
  urls.build.packs.packSources.create(),
  urls.build.packs.packSources.details(),
  urls.build.packs.packSources.edit(':id'),
];

export const buildUrlsGroup = [...dataModelsUrls, ...detectionsUrls, ...helpersUrls, ...packsUrls];
